import TableComponent from '@/Components/Table/Table';
import './ModuleManage.scss';
import { Button, Typography, Flex } from 'antd';
import { COLUMNS, DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from './constant';
import AddModal from './Components/AddModal';
import { useState } from 'react';
import { ModuleItem, SearchForm } from './types';
import useModuleList from '@/Apis/hooks/queries/useModuleList/useModuleList';
import useGetAuth from '@/hooks/useGetAuth';
import SearchBar from './Components/SearchBar';

const PageManage = () => {
	const [isOpenModal, setIsOpen] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [pageItem, setPageItem] = useState<ModuleItem>();
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
	const [filters, setFilters] = useState<SearchForm>()

	const { data, refetch } = useModuleList({ 
		page, pageSize,
		...(filters?.moduleId && {moduleId: filters?.moduleId}),
		...(filters?.remark && {remark: filters?.remark})
	});

	const {
		isAuthAdd,
		isAuthDelete
		
	} = useGetAuth()

	const openModal = () => {
		setIsOpen(true);
	};

	const closeModal = () => {
		setIsEditMode(false);
		setIsOpen(false);
		setPageItem(undefined);
	};

	const handleClickUpdate = (data: ModuleItem) => {
		setPageItem(data);
		setIsOpen(true);
		setIsEditMode(true);
	};

	const handleSearch = (filter: SearchForm) => {
		console.log('handleSearch filter', filter)
		setFilters(filter)
	};
	return (
		<>
			{isOpenModal && (
				<AddModal
					id={pageItem?.id || 0}
					onClose={closeModal}
					isEditMode={isEditMode}
					refetch={refetch}
				/>
			)}
			<div className='top-section'>
				<Typography.Title level={3}>Module Management</Typography.Title>
				<Flex justify='space-between' style={{
					marginTop: '50px'
				}}>
					<SearchBar onSearch={handleSearch} />
					{isAuthAdd && <Button type='primary' onClick={openModal}>
						Add Module
					</Button>}
				</Flex>
			</div>

			<div className='table-section'>
				<TableComponent
					defaultPageSize={DEFAULT_PAGE_SIZE}
					pageSizeOptions={PAGE_SIZE_OPTIONS}
					columns={COLUMNS}
					data={data.data.list.map((item) => ({
						key: item.id,
						name: item.name,
						shortName: item.shortName,
						creatorId: item.creatorId,
						id: item.id,
						remark: item.remark,
						createTime: item.createTime,
						updateTime: item.updateTime
					}))}
					onPageChange={(page) => {
						setPage(page);
					}}
					onPageSizeChange={(_, size) => {
						setPageSize(size);
					}}
					totalData={data.data.total}
					operations={[
						...isAuthAdd ? [{
							title: 'Edit',
							action: (item: any) => handleClickUpdate(item as ModuleItem),
						}] : [],
						// adjust later when delete is enabled
						// ...isAuthDelete ? [{
						// 	title: 'Delete',
						// 	action: (item: any) => {},
						// }] : [],
						
					]}
				/>
			</div>
		</>
	);
};
export default PageManage;
